<ng-template #content>
    @if (loading) {
        <div class="w-100 d-flex scss-attendance-drawer-gap-12 align-items-center justify-content-center py-3">
            <div 
                [attr.data-sb-qa]="qaTag + '-loading-spinner'"
                class="spinner-border base-100" 
                style="width: 2rem; height: 2rem;">
            </div>
        </div>
    } @else {
        <ng-content></ng-content>
    }
</ng-template>
